import { FaArrowRight, FaConnectdevelop } from "react-icons/fa";
import quizCard from "../../assests/quiz.svg";

const QuizCard = () => {
  const handleButtonClick = () => {
    // Navigate to a link in new window
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLScJyHv9vfwzCZt7fLDHw7rJZ23RL05QkRQtHlcCqQegxoCobQ/viewform?usp=sf_link",
      "_blank"
    );
  };
  return (
    //<div className="flex bg-white justify-center items-center rounded-2xl h-auto py-10  w-[90%] m-4  bg-gradient-to-b from-gray-300 to-transparent border-y-2 ">
    <div className="flex bg-primary2 justify-center items-center  py-10 w-[95vw] h-full lg:h-[250px] mx-2.5 p-3 rounded-xl">
      <div className="flex flex-col mr-9">
        <p className="text-black text-xl">Take Quiz On AI</p>
        {/* <p className="text-gray-500">build your resume</p> */}
        <button
          className="mt-2 hover:bg-primary border-primary border w- px-3 py-2 flex items-center rounded-xl justify-center"
          onClick={handleButtonClick}>
          <FaArrowRight />
        </button>
      </div>
      <div className="bg-primary2 rounded-md p-5 h-auto ">
        <img
          src={quizCard}
          alt="quizImage"
          className="h-20 w-20 object-cover"
        />
      </div>
    </div>
  );
};

export default QuizCard;
